import React from 'react';

import { Milestone } from 'models/shipments';
import { getFutureMilestones, showEdd } from 'utils/milestone.utils';

import { useCurrentArticle } from '../../hooks/shipment.hooks';
import CurrentMilestone from '../CurrentMilestone/CurrentMilestone';
import FutureMilestones from '../FutureMilestones/FutureMilestones';
import { OVERVIEW_VIEW_TEST_ID } from './OverviewView.test-ids';

import styles from './OverviewView.module.scss';

const OverviewView: React.FC = () => {
  const { address, events } = useCurrentArticle() || {};
  const latestEvent = events?.length ? events[0] : null;
  const latestMilestone = latestEvent?.milestone || Milestone.PENDING;
  const addressType = address?.addressType || null;
  const futureMilestone = getFutureMilestones(latestMilestone, addressType);

  return (
    <div
      id='OverviewTabPanel'
      className={styles.overviewView}
      role='tabpanel'
      aria-labelledby='OptionOverview'
      tabIndex={0}
      data-testid={OVERVIEW_VIEW_TEST_ID}
    >
      <p className={styles.subtitle}>LATEST</p>
      <CurrentMilestone
        milestone={latestMilestone}
        events={latestEvent && [latestEvent]}
        displayMilestoneTooltip
        displayLocalTimeFootnote
        hasNext={!!futureMilestone?.length}
      />
      {!!futureMilestone?.length && (
        <>
          <div className={styles.divider} />
          <FutureMilestones milestones={[futureMilestone[0]]} heading='NEXT' hasNext={showEdd(latestMilestone)} />
        </>
      )}
    </div>
  );
};

export default OverviewView;
